module.exports = __webpack_public_path__ + "static/img/log_top.e19dce98.svg";